<template>
  <div class="heights">
    <div class="banners">
      <img v-if="banner" :src="banner" alt="" />
      <img v-else src="../image/yky/banner空白图.png" alt="" />
      <span class="guide" @click="openGuide">操作指引</span>
    </div>
    <div class="padding-content">
      <!-- 微信信息 -->
      <div class="wx-msg">
        <img v-if="head_img_url" :src="head_img_url" alt="" />
        <img v-else src="../image/yky/头像空白图.png" alt="" />
        <div class="wx-name">
          <div class="wx-name_text">
            <b>{{ nick_name || "客户" }}</b>
            <button class="copy_uid" @click="onCopyUidHandle">复制uid</button>
          </div>
          <span>集积分，换好礼</span>
        </div>
        <div class="exchange-btn" @click="toExchange">
          <i></i>
          <span>兑换记录</span>
        </div>
      </div>
      <!-- 防伪码 -->
      <div class="code">
        <span class="txt">防伪码</span>
        <span v-if="bottle_code != 'undefined'">{{ bottle_code }}</span>
        <span class="copy" @click="copy">复制</span>
      </div>
      <!-- 活动列表 -->
      <div class="activity-list">
        <ul
          :style="{ width: widthTotal }"
          v-if="activityList && activityList.length > 1"
        >
          <li v-for="(item, index) in activityList" :key="index">
            <p>{{ item.name }}</p>
            <div class="count">
              <b>{{ item.userIntegral }}</b>
              <span>积分</span>
            </div>
            <div class="to-link" @click="introduce(item.description)">
              <span>活动介绍</span>
              <i></i>
            </div>
          </li>
        </ul>
        <div
          class="activity-des"
          v-if="activityList && activityList.length === 1"
        >
          <div class="count">
            <span>{{ activityList[0].name }}</span>
          </div>
          <div class="exchange-btn">
            <b>{{ activityList[0].userIntegral }}</b>
            <span>积分</span>
          </div>
        </div>
      </div>
      <!-- 活动介绍 -->
      <div
        class="activity-des"
        v-if="activityList && activityList.length === 1"
      >
        <h3>活动介绍</h3>
        <div class="des">
          <div v-html="description"></div>
          <div class="more">
            <i></i>
            <span @click="introduce(description)">查看更多</span>
          </div>
        </div>
      </div>
      <!-- 商品列表 -->
      <div class="product-list">
        <h3>商品兑换</h3>
        <ul v-if="productList && productList.length > 1">
          <li v-for="(item, index) in productList" :key="index">
            <div class="img" @click="toDel(item.productId)">
              <img v-if="item.image" :src="item.image" alt="" />
              <img v-else src="../image/yky/商品空白图.png" alt="" />
              <i class="zhe-icon" v-if="item.inventory <= 0">已抢光</i>
            </div>
            <div class="padding-content">
              <p>{{ item.productName }}{{ item.skuName }}</p>
              <div class="add-cart">
                <div class="count">
                  <b>{{ item.integral }}</b>
                  <span>积分起</span>
                </div>
                <i class="add-icon" @click="openpopup(item, index)"></i>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="productList && productList.length === 1" class="product-one">
          <div class="left" @click="toDel(productList[0].productId)">
            <img
              v-if="productList[0].image"
              :src="productList[0].image"
              alt=""
            />
            <img v-else src="../image/yky/商品空白图.png" alt="" />
            <i class="zhe-icon" v-if="productList[0].inventory == 0">已抢光</i>
          </div>
          <div class="right">
            <p>{{ productList[0].productName }}{{ productList[0].skuName }}</p>
            <div class="add-cart">
              <div class="count">
                <b>{{ productList[0].integral }}</b>
                <span>积分起</span>
              </div>
              <i class="add-icon" @click="openpopup(productList[0], 0)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="showPopup"
      closeable
      round
      position="bottom"
      :style="{ height: '70%', paddingBottom: '90px' }"
    >
      <div class="sku-header">
        <div class="van-sku-header__img-wrap">
          <img :src="product.image" alt />
        </div>
        <div class="sku-right">
          <span class="van-sku_name">{{ product.productName }}</span>
          <div class="s_center">{{ product.skuName }}</div>
        </div>
      </div>
      <div class="tips">{{submitCaution}}</div>
      <!-- 组合商品规格 -->
      <div class="combine" v-if="product.group">
        <p>组合商品明细</p>
        <div class="combine_detial">
          <div
            class="combine_item"
            v-for="(combine, index) in product.group"
            :key="index"
          >
            <img :src="combine.image ? combine.image : defaultimg" alt />
            <div class="sku_detial">
              <div class="sku_name">{{ combine.name }}</div>
              <div class="flex just-between align-center">
                <div class="sku_spec"></div>
                <div class="sku-num">x {{ combine.count }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="guige">
        <p>支付方式</p>
      </div>
      <div class="sku_list" :style="topStyle">
        <ul>
          <li
            v-for="(item, index) in product.payPrice"
            :class="{ active: index === selectIndex }"
            :key="index"
            @click="selected(item, index)"
          >
            <p v-if="item.money">
              {{ item.integral }}积分 + {{ item.money }}元
            </p>
            <p v-else>{{ item.integral }}积分</p>
          </li>
        </ul>
      </div>
      <div class="fixed-btn">
        <div class="sku-stepper">
          <span class="stepper-l">购买数量</span>
          <div class="stepper-r">
            <div class="r-m" @click="isRreduce('down')">
              <img src="../image/reduce@2x.png" alt />
            </div>
            <input type="number" v-model="count" @blur="checkNumber()" />
            <div class="r-a" @click="isRreduce('add')">
              <img src="../image/add@2x.png" alt />
            </div>
          </div>
        </div>
        <div class="btns">
          <!-- <van-button
            round
            v-if="limit && stock <= 0"
            type="info"
            :disabled="true"
            >{{ disablePay ? tips : "库存不足" }}</van-button
          > -->
          <van-button round type="info" @click="addCart(product)">
            加入购物车</van-button
          >
        </div>
      </div>
    </van-popup>
    <!-- 操作指引 -->
    <PopupTemp
      :popupVisible="isShow"
      @closePopup="closePopup"
      :content="content"
      :title="title"
      :height="height"
      closeOnClickOverlay
    />
    <DialogTemp
      :show="tipsShow"
      :integral="integral"
      :title="title"
      :text="text"
      @closeDialog="closeDialog"
      @submitTips="submitTips"
    />
    <ToBack :offset-bottom="'150'" />
    <Cart :cartTotal="cartTotal" :userIntegral="userIntegral" />
  </div>
</template>

<script>
import http from "../common/http.js";
import PopupTemp from "./common/popup.vue";
import DialogTemp from "./common/dialog.vue";
import ToBack from "./common/toback.vue";
import Cart from "./common/cart.vue";
import { Toast } from "vant";
// import Clipboard from 'clipboard'
export default {
  components: { PopupTemp, ToBack, DialogTemp, Cart },
  name: "HelloWorld",
  data() {
    return {
      t: this.$route.query.s,
      head_img_url: this.$route.query.head_img_url,
      nick_name: this.$route.query.nick_name,
      presentation: "",
      counts: 0,
      addreslsit: {},
      bottle_code: this.$route.query.bottle_code || sessionStorage.getItem("currentTCode") || "",
      tableHeight: window.innerHeight,
      banner: "",
      widthTotal: 187 * 3 + "px",
      isShow: false,
      content: "",
      title: "",
      productList: [],
      cacheGoods: [],
      activityList: [],
      integral: null,
      text: "",
      tipsShow: false,
      zhiyin: "",
      description: "",
      height: "300",
      userIntegral: null,
      showPopup: false,
      product: {
        barcode: "4897070509382",
        image:
          "https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/product/20222/6217180d9e173bdda493a629.jpg",
        integral: "50",
        inventory: "93312",
        productId: "604971cd0c7a43580b2174fe",
        productName: "焕亮精华两部曲面膜",
        skuId: "60497d490c7a43580b217506",
        skuName: "-|-|10片*-",
        skuList: [
          {
            num: 50,
            price: 9.99,
          },
          {
            num: 50,
            price: 9.99,
          },
          {
            num: 50,
          },
        ],
        sku_group: [
          {
            img: "",
            name: "婴幼儿保湿面霜婴幼儿保湿面霜婴幼儿保湿哈哈哈哈哈哈哈.",
            count: "1",
            skuname: "NB/40片/包",
          },
        ],
      },
      topStyle: {
        top: "180px",
      },
      defaultimg: require("../image/Pt_Img@2x.png"),
      selectIndex: "",
      count: 1,
      curpayPrice: [],
      submitCaution:'',
      unionId:""
    };
  },
  mounted() {
    localStorage.removeItem("ykygoodsList");
    if (JSON.parse(sessionStorage.getItem("ykygoodsList"))) {
      this.cacheGoods = JSON.parse(sessionStorage.getItem("ykygoodsList"));
    } else {
      this.cacheGoods = [];
    }
    localStorage.setItem("nick_name", this.nick_name);
    if (
      this.$route.query.bottle_code != "undefined" &&
      !sessionStorage.getItem("codeintegral")
    ) {
      this.acyives();
    } else {
      this.getActivity();
    }
    this.getHome();
  },
  computed: {
    cartTotal() {
      let total = 0;
      this.cacheGoods &&
        this.cacheGoods.forEach((v) => {
          total += Number(v.count) ;
        });
      return total;
    },
    totalPrice() {
      let total = 0;
      let arr =
        this.cacheGoods &&
        this.cacheGoods.filter((el) => {
          return el.count != 0;
        });
      arr &&
        arr.forEach((v) => {
          total += Number(v.integral) * Number(v.count);
        });
      return total;
    },
  },
  methods: {
    isRreduce(type){
      if(type=='down' && this.count!=0){
        this.count=this.count-1
      }else if(type=='add'){
        this.count=this.count+1
      }
    },
    //选择支付方式
    selected(item, index) {
      this.selectIndex = index;
      this.curpayPrice = [];
      this.curpayPrice.push(item);
    },
    // 积累积分
    acyives() {
      http.get("/integral/public/integral/log/add").then((res) => {
        // res.reason错误提示
        if (!res.reason) {
          this.getActivity();
          this.tipsShow = true;
          this.title = "恭喜您";
          this.text =
            '<p style="margin-top:30px">本次积分已成功</p><p>欢迎每日来打卡噢~</p>';
          // this.integral = res.message
          sessionStorage.setItem("codeintegral", res.message);
        } else {
          this.getActivity();
          this.tipsShow = true;
          this.text = `<p style="margin-top:60px">${res.message}</p>`;
          sessionStorage.setItem("codeintegral", res.message);
        }
      });
    },
    closeDialog() {
      this.tipsShow = false;
    },
    submitTips() {
      this.tipsShow = false;
    },
    getActivity() {
      http.get("/integral/public/activity/get").then((res) => {
        this.activityList = res.data;
        this.widthTotal = 187 * res.data.length + "px";
        this.description = res.data[0].description;
        this.userIntegral = Number(this.activityList[0].userIntegral);
      });
    },
    getHome() {
      http.get("/integral/public/indexpage/get").then((res) => {
        this.banner = res.image;
        this.zhiyin = res.operationGuide;
        res.productList.forEach((v) => {
          v.count = 0;
        });
        this.productList = res.productList || [];
        this.submitCaution= res.submitCaution
        sessionStorage.setItem("submitCaution", res.submitCaution);
      });
    },

    copy() {
      this.$copyText(this.bottle_code).then(
        () => {
          this.$toast("复制成功");
        },
        () => {
          this.$toast("复制失败，请重新复制");
        }
      );
    },
    openGuide() {
      this.isShow = true;
      this.title = "操作指引";
      this.content = this.zhiyin;
      this.height = "300";
    },
    closePopup() {
      this.isShow = false;
    },
    toDel(item) {
      this.$router.push("/productDel?id=" + item);
    },
    toExchange() {
      this.$router.push("/exchangeList");
    },
    introduce(item) {
      this.isShow = true;
      this.title = "活动介绍";
      this.content = item;
      this.height = "490";
    },
    openpopup(item) {
      this.showPopup = true;
      this.count=1
      this.product = JSON.parse(JSON.stringify(item)) ;
      // this.addCart(item)
    },
    // 添加商品到购物车
    addCart(item) {
      if( this.curpayPrice.length==0){
        Toast({
          duration: 2000,
          message: "请选择支付方式",
        });
        return;
      }
      console.log(item,this.cacheGoods, "item");
      if (item.inventory == 0) {
        Toast({
          duration: 2000,
          message: "当前商品已抢光",
        });
        return;
      }
      if (
        Number(this.activityList[0] && this.activityList[0].userIntegral) < Number(item.integral) ||
        Number(this.activityList[0] && this.activityList[0].userIntegral) <
          this.totalPrice + Number(item.integral)
      ) {
        Toast({
        duration: 2000,
        message: '当前积分不足',
      })
        return;
      }
      this.showPopup = false;
      this.selectIndex=''
      if (this.cacheGoods.length > 0) {
        let flag=1
        for(let i=0;i<this.cacheGoods.length;i++){
          console.log(this.cacheGoods,this.curpayPrice,this.cacheGoods[i].curpayPrice[0]===this.curpayPrice[0], 0)

          if(this.cacheGoods[i]._id == this.product._id &&  this.cacheGoods[i].curpayPrice[0].integral == this.curpayPrice[0].integral 
          && (this.cacheGoods[i].curpayPrice[0].money == this.curpayPrice[0].money)){
            //this.cacheGoods[i].curpayPrice[0]===this.curpayPrice[0]
            console.log(1) 
            this.cacheGoods[i].count = this.cacheGoods[i].count + Number(this.count) ;
            flag=2
            console.log(this.cacheGoods,'this.cacheGoods1')
            break;
          }
        }
        if(flag==1){
          console.log(2)
          this.product.count = this.count;
          this.product.curpayPrice = this.curpayPrice;
          this.cacheGoods.push(this.product);
          console.log(this.cacheGoods,'this.cacheGoods2')
        }
      } else {
        this.product.count = this.count;
        this.product.curpayPrice = this.curpayPrice;
        this.cacheGoods.push(this.product);
        console.log(this.cacheGoods,'this.cacheGoods3')
      }
      sessionStorage.setItem("ykygoodsList", JSON.stringify(this.cacheGoods));
    },
    async onCopyUidHandle(){
      if(!this.unionId){
        const res = await http.get("/integral/public/copy/unionId")
        this.unionId = res.data
      }
      await this.$copyText(this.unionId)
      Toast({message:"复制成功"})
    }
  },
};
</script>

<style lang="scss" scoped >
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.just-between {
  justify-content: space-between;
}
.banners {
  width: 100%;
  height: 200px;
  position: relative;
  text-align: center;
  img {
    width: 100%;
    height: 200px;
  }
  .guide {
    display: inline-block;
    position: absolute;
    right: 0;
    top: 32px;
    width: 35px;
    height: 109px;
    border-radius: 15px 0 0 15px;
    color: #d80a68;
    font-size: 14px;
    background: #fff;
    writing-mode: vertical-lr;
    writing-mode: tb-lr;
    padding-left: 8px;
    letter-spacing: 4px;
  }
}
.padding-content {
  padding: 0 12px;
  .wx-msg {
    position: relative;
    z-index: 2;
    margin-top: -30px;
    background: #fff;
    padding: 15px;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      margin-right: 15px;
    }
    .wx-name {
      flex: 1;
      display: flex;
      flex-direction: column;
      b {
        font-size: 14px;
        font-weight: bold;
        // margin-bottom: 4px;
      }
      .wx-name_text{
        margin-bottom: 4px;
        display:flex;
        align-items: center;
        b{
          display: inline-block;
          width: 110px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .copy_uid{
          width: 53px;
          height: 20px;
          background: #F9E0EB;
          border-radius: 12px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #D80A68;
          text-align: center;
          line-height:20px;
          border:none;
          outline:none;
          padding: 0;
        }
      }
    }
    .exchange-btn {
      width: 90px;
      height: 28px;
      line-height: 28px;
      border-radius: 15px;
      border: 1px solid #d80a68;
      color: #d80a68;
      font-size: 12px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        display: inline-block;
        width: 15px;
        height: 15px;
        background: url("../image/yky/兑换记录.png") no-repeat;
        background-size: contain;
        margin-right: 4px;
      }
    }
  }

  .code {
    background: #f4edf5;
    border-radius: 15px;
    padding: 40px 12px 12px;
    margin-top: -20px;
    .txt {
      font-size: 12px;
      font-weight: bold;
      margin-right: 10px;
    }
    .copy {
      display: inline-block;
      width: 40px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: #fff;
      border-radius: 12px;
      float: right;
    }
  }

  .activity-list {
    width: 100%;
    overflow-x: scroll;
    margin: 10px 0 20px;
    ul {
      display: flex;
      li {
        background: #fff;
        padding: 20px 15px;
        border-radius: 15px;
        margin-right: 10px;
        width: 187px;
        height: 112px;
        p {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .count {
          font-weight: bold;
          b {
            font-size: 20px;
            color: #d80a68;
            margin-right: 8px;
          }
          span {
            font-size: 14px;
          }
        }
        .to-link {
          margin-top: 8px;
          display: flex;
          justify-content: space-between;
          i {
            display: block;
            width: 16px;
            height: 16px;
            background: url("../image/yky/箭头.png") no-repeat;
            background-size: contain;
          }
        }
      }
    }
    .activity-des {
      width: 100%;
      height: 70px;
      background: #fff;
      border-radius: 15px;
      padding: 20px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .count {
        font-weight: bold;
      }
      .exchange-btn {
        font-weight: bold;
        b {
          font-size: 20px;
          color: #d80a68;
          margin: 0 8px;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }

  .activity-des {
    h3 {
      height: 22px;
      font-size: 14px;
      font-weight: bold;
      color: #222222;
      position: relative;
      padding-left: 10px;
      margin-bottom: 10px;
      &::before {
        display: block;
        content: "";
        position: absolute;
        top: 4px;
        left: 0;
        width: 3px;
        height: 12px;
        background: #d80a68;
        border-radius: 1px;
      }
    }
    .des {
      width: 100%;
      height: 150px;
      border-radius: 15px;
      background: #fff;
      padding: 20px;
      > div {
        height: 72px;
        overflow: hidden;
      }
      .more {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 86px;
        height: 22px;
        border: 1px solid #d80a68;
        line-height: 22px;
        border-radius: 15px;
        color: #d80a68;
        text-align: center;
        margin: 15px auto 0;
        i {
          display: inline-block;
          width: 15px;
          height: 15px;
          background: url("../image/yky/20220222-171817.png") no-repeat;
          background-size: contain;
          margin-right: 4px;
        }
      }
    }
  }

  .product-list {
    margin-top: 20px;
    padding-bottom: 20px;
    h3 {
      height: 22px;
      font-size: 14px;
      font-weight: bold;
      color: #222222;
      position: relative;
      padding-left: 10px;
      margin-bottom: 10px;
      &::before {
        display: block;
        content: "";
        position: absolute;
        top: 4px;
        left: 0;
        width: 3px;
        height: 12px;
        background: #d80a68;
        border-radius: 1px;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 48.5%;
        background: #fff;
        border-radius: 12px;
        padding-bottom: 16px;
        margin-bottom: 10px;
        .img {
          width: 100%;
          height: 165px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            border-radius: 12px;
          }
          .zhe-icon {
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 66px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            background: rgba(0, 0, 0, 0.7);
            color: #fff;
            border-radius: 12px;
            z-index: 2;
          }
        }
        .padding-content {
          padding: 0 14px 0 12px;
          p {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 2;
          }
        }
        p {
          font-size: 14px;
          color: #333333;
          margin: 8px 0 14px 0;
        }
        .add-cart {
          display: flex;
          justify-content: space-between;
          .count {
            color: #d80a68;
            font-weight: bold;
            b {
              font-size: 16px;
              margin-right: 2px;
            }
          }
          .add-icon {
            display: block;
            width: 20px;
            height: 20px;
            background: url("../image/yky/添加商品@2x.png") no-repeat;
            background-size: contain;
          }
        }
      }
    }
    .product-one {
      display: flex;
      border-radius: 12px;
      background: #fff;
      .left {
        width: 140px;
        height: 140px;
        position: relative;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 12px;
        }
        i {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 66px;
          height: 25px;
          line-height: 25px;
          text-align: center;
          background: rgba(0, 0, 0, 0.7);
          color: #fff;
          border-radius: 12px;
          z-index: 2;
        }
      }
      .right {
        padding: 12px 15px 17px 0;
        position: relative;
        flex: 1;
        p {
          font-size: 16px;
          color: #333333;
        }
        .add-cart {
          display: flex;
          justify-content: space-between;
          position: absolute;
          left: 0;
          right: 15px;
          bottom: 17px;
          .count {
            color: #d80a68;
            font-weight: bold;
            b {
              font-size: 16px;
              margin-right: 2px;
            }
          }
          .add-icon {
            display: block;
            width: 20px;
            height: 20px;
            background: url("../image/yky/添加商品@2x.png") no-repeat;
            background-size: contain;
          }
        }
      }
    }
  }
}
.van-popup--bottom {
  padding-top: 15px;
  .sku-header {
    width: 100%;
    height: 100px;
    padding: 15px 20px 0;
    display: flex;
    .van-sku-header__img-wrap {
      float: left;
      width: 84px;
      height: 84px;
      margin: 5px 0;
      overflow: hidden;
      padding: 10px;
      box-sizing: border-box;
      img {
        width: 100%;
      }
    }
    .sku-right {
      margin-left: 5px;
      // padding-top: 49px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .s_center {
        display: flex;
        margin-top: 2px;
        span {
          display: inline-block;
          font-size: 10px;
          color: #999;
          padding: 0 4px;
          border: 1px solid #999;
          border-radius: 2px;
          margin-top: 2px;
          &.active {
            color: #ff5f00;
            border: 1px solid #ff5f00;
          }
          &.new {
            color: #4380f1;
            border: 1px solid #4380f1;
          }
        }
      }
      span {
        display: block;
      }
      .van-sku_name {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 22px;
      }
      .van-sku-s {
        margin-top: 5px;
        display: flex;
        align-items: center;
        .van-sku_pirces {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          line-height: 14px;
          -webkit-transform: scale(0.84);
        }
        .van-sku__price-symbol {
          font-size: 14px;
          font-family: DIN-Regular, DIN;
          font-weight: 400;
          color: rgba(254, 83, 83, 1);
          line-height: 17px;
          -webkit-transform: scale(0.84);
        }
        .van-sku__price-num {
          margin-bottom: 5px;
          margin-right: 2px;
          font-size: 20px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: rgba(254, 83, 83, 1);
          line-height: 24px;
        }
        .van-sku__price-delete {
          font-size: 12px;
          font-family: DIN-Regular, DIN;
          font-weight: 400;
          color: #c2c2c2;
          line-height: 15px;
          text-decoration: line-through;
        }
      }
    }
    .sku-num {
      display: flex;
      span {
        font-size: 12px;
      }
      .red {
        color: red;
      }
    }
  }
  .subtitle {
    font-size: 12px;
    margin-left: 15px;
    margin-bottom: 5px;
    span {
      display: inline-block;
      margin-left: 20px;
    }
  }
  .scroll_warp {
    padding-bottom: 80px;
  }
  .guige {
    margin-left: 15px;
    p {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
    }
  }
  .sku_list {
    // position: absolute;
    // bottom: 150px;
    // overflow-y: scroll;
    // -webkit-overflow-scrolling: touch;
  }
  ul {
    margin-top: 10px;
    width: 100%;
    padding: 0 15px 15px;
    display: flex;
    flex-wrap: wrap;
    li {
      margin-right: 12px;
      margin-top: 5px;
      // height: 28px;
      text-align: center;
      line-height: 12px;
      background-color: #f6f6f6;
      border: 1px solid #fff;
      border-radius: 2px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      padding: 8px 6px;
      &.active {
        background: #ffedf5;
        border: 1px solid #d80a68;
        font-weight: 600;
        color: #d80a68;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .sku-stepper {
    background-color: #fff;
    margin-top: 15px;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    align-items: center;
    // position: absolute;
    // bottom: 60px;
    .stepper-l {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
    }
    .stepper-r {
      display: flex;
      .r-m {
        width: 22px;
        height: 22px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      input {
        width: 34px;
        height: 22px;
        border-radius: 10px;
        font-size: 15px;
        margin: 0 3px;
        // background-color: #f7f9fc;
        text-align: center;
        color: #000000;
      }
      .r-a {
        width: 22px;
        height: 22px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .btns {
    width: 100%;
    padding: 0 15px;
    height: 44px;
    margin: 0 auto;
    .van-button {
      margin: 0 auto;
      display: block;
      width: 100%;
      height: 40px;
      line-height: 0px;
      border: none;
      background: #d80a68;
      // background: linear-gradient(to right, #386fef, #5094f5);
    }
    .van-button--normal {
      color: #fff;
      font-size: 14px;
      padding: 0;
    }
  }
  .btnaddquan {
    width: 100%;
    padding: 0 15px;
    height: 44px;
    display: flex;
    justify-content: space-around;
    .btn {
      flex: 1;
      color: #ffffff;
      font-size: 16px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      border-radius: 25px;
      background: linear-gradient(to right, #386fef, #5094f5);
    }
    .quan_btn {
      background-color: rgb(255, 70, 2);
      margin-left: 20px;
    }
  }
}
// /deep/ .van-sku-row__item--active {
//   background-color: #4380f1;
//   color: #fff;
// }
// /deep/ .van-sku-actions .van-button:first-of-type {
//   border-top-left-radius: 20px;
//   border-bottom-left-radius: 20px;
//   border-top-right-radius: 20px;
//   border-bottom-right-radius: 20px;
// }
// /deep/ .van-button--danger {
//   display: none;
// }
// /deep/ .van-sku-row__item {
//   margin: 5px 4px 5px 0px;
// }
// // 减少
// /deep/ .van-stepper__minus {
//   width: 22px;
//   height: 22px;
//   padding: 5px;
//   border-radius: 50%;
//   background: url('../../cmmon/image/public/减少.png');
//   background-size: contain;
// }
// /deep/ .van-stepper__minus::before {
//   display: none;
// }
// // 增加
// /deep/ .van-stepper__plus {
//   width: 22px;
//   height: 22px;
//   padding: 5px;
//   border-radius: 50%;
//   background: url('../../cmmon/image/public/添加.png');
//   background-size: contain;
// }
// /deep/ .van-stepper__plus::after {
//   display: none;
// }
// /deep/ .van-stepper__plus::before {
//   display: none;
// }
// /deep/ .van-sku-row__title {
//   padding: 0;
//   font-size: 14px;
//   font-weight: 600;
// }
// /deep/.van-stepper__input {
//   width: 34px;
//   height: 22px;
//   border-radius: 10px;
// }
.fixed-btn {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.tips {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff4446;
  line-height: 18px;
  margin: 20px;
}

.combine {
  margin-left: 15px;

  p {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
  }

  .combine_detial {
    width: 100%;
    height: fit-content;
    padding: 12px 28px 12px 0;

    & + .combine_detial {
      padding: 0px 28px 12px 0;
    }

    .combine_item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;
      overflow: hidden;
      img {
        width: 60px;
        height: 60px;
      }

      .sku_detial {
        flex: 1;
        margin-left: 12px;
        align-items: center;
        justify-content: space-between;
        overflow: hidden;
        .sku_name {
          width: 100%;
          font-size: 13px;
          font-weight: 500;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #333333;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          /* 指定显示的行数 */
          overflow: hidden;
          text-overflow: ellipsis;
          // white-space: nowrap;
          margin-bottom: 2px;
        }

        .sku_spec {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          -webkit-text-size-adjust: none;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          /* 指定显示的行数 */
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
        }

        .sku-num {
          text-align: right;
          font-weight: 600;
          // width:50px;
          font-size: 14px;
          -webkit-text-size-adjust: none;
          color: #d80a68ff;
          width: 50px;
        }
      }
    }
  }
}
</style>
